import { BehaviorParameters } from 'rangeConfig/@types';
import { getInteriorsInLoftBedCabinet } from '../utils/loftbed';

const addInteriorSuggestionToLoftBed = ({ coreApi, props }: BehaviorParameters) => {
  const selectedEntity = coreApi.entities.findSelectedEntity();

  if (!selectedEntity) return;

  const currentInteriorsInCabinet = getInteriorsInLoftBedCabinet(selectedEntity);
  coreApi.entities.deleteMultiple(currentInteriorsInCabinet);

  const interiorSuggestionEntity = coreApi
    .getServices()
    .productManager.createEntity(props.coreProductId);
  if (interiorSuggestionEntity) {
    coreApi.placementService.snapToConnector(
      interiorSuggestionEntity,
      'interior-suggestion-frame',
      selectedEntity,
      'cabinet-center'
    );
    coreApi.placementService.dissolveEntity(interiorSuggestionEntity);
  }
};

export default addInteriorSuggestionToLoftBed;
